import { notificationInstance } from '@/shared/api/api-instances/notification/api-instance';
import type { Receiver, ReceiverItem } from '../model/receiver';
import type { AxiosRequestConfig } from 'axios';

export class ReceiversApi {
  static getReceivers(options: AxiosRequestConfig = {}) {
    return notificationInstance.get<ReceiverItem[]>(`/receivers`, options);
  }

  static getReceiverByID(id: string, options: AxiosRequestConfig = {}) {
    return notificationInstance.get<Receiver>(`/receiver/${id}`, options);
  }

  static updateReceiver(
    id: string,
    payload: Omit<Receiver, 'id'>,
    options: AxiosRequestConfig = {},
  ) {
    return notificationInstance.put(`/receiver/${id}`, payload, options);
  }

  static createReceiver(
    payload: Omit<Receiver, 'id'>,
    options: AxiosRequestConfig = {},
  ) {
    return notificationInstance.post('/receiver', payload, options);
  }

  static deleteReceiver(
    id: string,
    force: boolean = false,
    options: AxiosRequestConfig = {},
  ) {
    return notificationInstance.delete<void>(`/receiver/${id}`, {
      ...options,
      params: { force: force },
    });
  }
}